import { useHistory } from "react-router-dom";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { apisiseci } from "../../api";
import { Totem } from "../../../@types/totem";
import { AxErrorResponse } from "../../../@types/axios-error-response";

export type TotemCreateData = Pick<
    Totem,
    | "descricao"
    | "cor_fonte"
    | "cor_fundo"
    | "token"
    | "senha_reset"
> & {
    local_atendimento: string
    orgao: number
    servicos: Array<string>
    prioridades: Array<string>
    logo: File
}

export function useTotemCreate() {
    const history = useHistory();
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation<
        Totem,
        AxiosError<AxErrorResponse>,
        TotemCreateData
    >({
        mutationKey: ["totem", "create"],
        mutationFn: async (data) => {
            const payload = new FormData();
            Object.entries(data).forEach(([key, value]) => {
                if (value instanceof File) {
                    payload.append(key, value);
                } else if (Array.isArray(value)) {
                    if (value.length === 1) {
                        payload.append(key, String(value[0]) + ',');
                    } else {
                        payload.append(key, String(value));
                    }
                } else {
                    payload.append(key, String(value));
                }
            });
            payload.append("ativo", "true");
            const response = await apisiseci.post<Totem>(
                '/cms/totens/', payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data",
                    }
                }
            );
            return response.data;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ["totem", "list"] })

            toast.success("Totem cadastrado com sucesso!");
            history.push("/totens");
        },
        onError: (error) => {
            console.error("Error creating totem:", error);
            const data = error?.response?.data || {};

            Object.keys(data).forEach((key) => {
                if (Array.isArray(data[key]) && data[key].length > 0) {
                    toast.error(data[key][0]);
                } else if (typeof data[key] === "string") {
                    toast.error(data[key]);
                }
            });

            if (Object.keys(data).length === 0) {
                toast.error("Algo deu errado, tente novamente!");
            }
        },
    });

    return mutation;
}
